import TravelRuleTableItemDetails from './TravelRuleTableItemDetails'

export default TravelRuleTableItemDetails
